import { Col, Row } from "v2/components/base/Flex/ui";
import AppSideBarUI from "./ui";
import { navigationItems } from "v2/routes";

export const AppSideBar = ({ width }: { width?: string }) => {
  return (
    <AppSideBarUI.Wrapper width={width}>
      <Col type="ss" sx={{ gap: "33px" }}>
        <AppSideBarUI.Header />
        <Col type="ss" sx={{ gap: "16px" }}>
          {navigationItems.map((item) => (
            <AppSideBarUI.Nav.Wrapper route={item.route}>
              <AppSideBarUI.Nav.Icon icon={item.icon} />
              <AppSideBarUI.Nav.Nav route={item.route} label={item.label} />
            </AppSideBarUI.Nav.Wrapper>
          ))}
        </Col>
      </Col>
      <Col section="profile" type="cs" sx={{ gap: "8px" }} fullWidth>
        <AppSideBarUI.Profile.UserName />
        <AppSideBarUI.Profile.Logout />
      </Col>
    </AppSideBarUI.Wrapper>
  );
};
